import {HTTP} from './httpSvc'





export const getMe = () => HTTP.get(`accounts/me`)
export const getRuns = () => HTTP.get(`runs/account/${localStorage.getItem('accountId')}`)
export const getRun = (runId) => HTTP.get(`runs/${runId}?steps=500`)
export const getRunFinalStage = (runId) => HTTP.get(`runs/final/${runId}`)

export const saveMeasurements = (jsonData) => HTTP.postJson(`measurements/account/${localStorage.getItem('accountId')}`, jsonData)

export const getMeasurements = () => HTTP.get(`measurements/account/${localStorage.getItem('accountId')}`)

export const postPhotos = (formData) => HTTP.postMultipartFormData( `photos/account/${localStorage.getItem('accountId')}?camera_id=1`, formData)


export const createAccount = (body) => HTTP.postJson( `accounts/open`, body)
export const createCamera = (body) => HTTP.postJson( `camera`, body)
export const createAvatar  = (body) => HTTP.postJson( `jobs/account/${localStorage.getItem('accountId')}`, body);
